import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getTransactions, updateTransactionStatus } from '../../services/transaction';

// Async thunks
export const fetchTransactions = createAsyncThunk(
  'transaction/fetchTransactions',
  async (params = {}) => {
    const response = await getTransactions(params);
    return response;
  }
);

export const updateTransaction = createAsyncThunk(
  'transaction/updateTransaction',
  async ({ transactionId, status }) => {
    const response = await updateTransactionStatus(transactionId, status);
    return response;
  }
);

const initialState = {
  transactions: [],
  loading: false,
  error: null,
  pagination: {
    current_page: 1,
    total_pages: 0,
    total_count: 0,
    limit: 10,
    has_next: false,
    has_previous: false
  },
  filters: {
    type: 'all',
    status: '',
    search: ''
  }
};

const transactionSlice = createSlice({
  name: 'transaction',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearError: (state) => {
      state.error = null;
    },
    resetTransactions: (state) => {
      state.transactions = [];
      state.pagination = initialState.pagination;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch transactions
      .addCase(fetchTransactions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.transactions = action.payload.transactions || [];
        state.pagination = action.payload.pagination || initialState.pagination;
      })
      .addCase(fetchTransactions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Update transaction
      .addCase(updateTransaction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTransaction.fulfilled, (state, action) => {
        state.loading = false;
        // Update the transaction in the list
        const updatedTransaction = action.payload.transaction;
        const index = state.transactions.findIndex(t => t.id === updatedTransaction.id);
        if (index !== -1) {
          state.transactions[index] = updatedTransaction;
        }
      })
      .addCase(updateTransaction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export const { setFilters, clearError, resetTransactions } = transactionSlice.actions;
export default transactionSlice.reducer;

